import {
  getEnterpriseWebsite,
  enterpriseInformation
} from '@/apiCloud/enterprise'

import router from '../../router'

const enterprise = {
  state: {
    enterpriseId: '',
    empName: '',
    webIco: '',
    webIeIco: '',
    entpWebsite: '',
    studyQrCode: '',
    entpTel: 'TEL loading...',
    entpType: '',
    studyEntpId:'',
    otherConfig:{}
  },

  mutations: {
    SET_ENTERPRISEID: (state, enterpriseId) => {
      state.enterpriseId = enterpriseId;
    },
    SET_EMPNAME: (state, empName) => {
      state.empName = empName;
    },
    SET_WEBICO: (state, webIco) => {
      state.webIco = webIco;
    },
    SET_WEBIEICO: (state, webIeIco) => {
      state.webIeIco = webIeIco;
    },
    SET_ENTPWEBSITE: (state, entpWebsite) => {
      state.entpWebsite = entpWebsite;
    },
    SET_STUDYQRCODE: (state, studyQrCode) => {
      state.studyQrCode = studyQrCode;
    },
    SET_ENTPTEL: (state, entpTel) => {
      state.entpTel = entpTel;
    },
    SET_ENTPTYPE:(state, entpType) => {
      state.entpType = entpType;
    },
    SET_STUDY_ENTPID:(state, studyEntpId) => {
      state.studyEntpId = studyEntpId;
    },
    SET_OTHER_CONFIG: (state, value) => {
      state.otherConfig = value || {};
    }
  },

  actions: {
    //获取企业信息
    GetEnterprise({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        // 获取企业ID
        getEnterpriseWebsite(data).then(response => {
          if (response.code == 200) {
            let entpId = response.data.entpId;
            commit('SET_ENTERPRISEID', entpId)
            localStorage.setItem("enterpriseId", response.data.entpId)
            localStorage.setItem("entpCreditNo", response.data.entpCreditNo)
            // 根据ID获取企业详情
            enterpriseInformation({
              entpId
            }).then(res => {
              if (res.code == 200) {
                let entInfo = res.data;
                sessionStorage.setItem('empName', entInfo.empName)
                commit('SET_EMPNAME', entInfo.empName);
                commit('SET_WEBICO', entInfo.webIco);
                commit('SET_WEBIEICO', entInfo.webIeIco);
                commit('SET_ENTPWEBSITE', entInfo.entpWebsite);
                commit('SET_STUDYQRCODE', entInfo.studyQrCode);
                commit('SET_ENTPTEL', entInfo.entpTel);
                commit('SET_ENTPTYPE', entInfo.entpType);
                
                document.title = entInfo.empName;
                // $("#browserIcon").attr("href", entInfo.webIeIco);
              }
            })
          } else {
            router.push('/null')
          }
          resolve(response)
        }).catch(error => {
          router.push('/null')
          reject(error)
        })
      })
    }
  }
}

export default enterprise



// WEBPACK FOOTER //
// ./src/store/modules/enterprise.js